import { FETCH_GRAPHIC_PERIODS_LOADING, FETCH_GRAPHIC_PERIODS } from "../actions/types";


const infoGraphicReducer =  (state = {}, action) => {
    switch (action.type) {
        case FETCH_GRAPHIC_PERIODS_LOADING:
            return {...state, 'loading': true };
        case FETCH_GRAPHIC_PERIODS:
            return { ...state,  [action.internalId]: action.payload ,'loading': false}
        default:
            return state;
    }
};

export default infoGraphicReducer;